import dayjs from "dayjs";

// The same persisted document mapping is used when reopening a form on either screen size.
export function saleFormData(order: any, items: any[]) {
  return {
    id: order.id, Date_Facture: order.order_date || dayjs().format("YYYY-MM-DD"),
    Statut_Vente: order.order_status || "Commandé", Client_ID: String(order.user_id),
    remise_globale: Number(order.manual_discount ?? order.discount) || 0,
    manual_discount: Number(order.manual_discount) || 0,
    loyalty_discount: Number(order.loyalty_discount) || 0,
    loyalty_discount_rate: Number(order.loyalty_discount_rate) || 0,
    loyalty_discount_applied: order.loyalty_discount_applied === true || Number(order.loyalty_discount_applied) === 1,
    termes_conditions: order.terms_condition || "", remarques: order.notes || "",
    invoice_subject: order.invoice_subject || "",
    paid_amount: Number(order.paid_amount) || 0, payment_status: order.payment_status || "Non payé",
    invoice_type: order.invoice_type || "standard",
    produitsVendus: items.map((item) => ({
      produit_id: item.item_type === "service" ? -Number(item.service_id) : Number(item.product_id),
      item_type: item.item_type || "product", product_id: item.product_id ?? null, service_id: item.service_id ?? null,
      nom_produit: item.product_name || item.item_name_snapshot || item.name || `Article #${item.product_id || item.service_id}`,
      quantite: Number(item.quantity), prix_unitaire_HT: Number(item.unit_price), remise: Number(item.discount_rate) || 0,
      taxe: item.tax_id, montant_taxe: Number(item.total_tax) || 0,
      unit_id: item.unit_id ?? item.unit?.id ?? null, unit_name: item.unit_name || item.unit?.name,
      unit_short_name: item.unit_short_name || item.unit?.short_name,
    })),
  };
}

export function purchaseFormData(order: any, items: any[]) {
  return {
    id: order.id, Date_Facture: order.order_date || dayjs().format("YYYY-MM-DD"), due_date: order.due_date || null,
    Statut_Achat: order.order_status || "Commandé", Fournisseur_ID: Number(order.user_id), warehouse_id: Number(order.warehouse_id),
    remise_globale: Number(order.discount) || 0, termes_conditions: order.terms_condition || "", remarques: order.notes || "",
    paid_amount: Number(order.paid_amount) || 0, supplier_name: order.supplier_name || order.user_name,
    purchase_order_id: order.purchase_order_id ?? order.Bon_Commande_ID ?? null,
    Bon_Commande_ID: order.purchase_order_id ?? order.Bon_Commande_ID ?? null,
    document_url: order.document_url || null, document_name: order.document_name || null,
    cout_transport: Number(order.extra_cost_transport) || 0, cout_assurance: Number(order.extra_cost_assurance) || 0,
    cout_douane: Number(order.extra_cost_douane) || 0, cout_autres_frais: Number(order.extra_cost_autres) || 0,
    inclus_transport: Number(order.extra_cost_transport_included) !== 0,
    inclus_assurance: Number(order.extra_cost_assurance_included) !== 0,
    inclus_douane: Number(order.extra_cost_douane_included) !== 0,
    inclus_autres: Number(order.extra_cost_autres_included) !== 0,
    produitsAches: items.map((item) => ({
      id: item.id, produit_id: Number(item.product_id),
      nom_produit: item.product_name || item.item_name_snapshot || item.name || `Produit #${item.product_id}`,
      quantite: Number(item.quantity), prix_unitaire_HT: Number(item.unit_price), remise: Number(item.discount_rate) || 0,
      taxe: item.tax_id, montant_taxe: Number(item.total_tax) || 0,
      unit_id: item.unit_id ?? item.unit?.id ?? null, unit_name: item.unit_name || item.unit?.name,
      unit_short_name: item.unit_short_name || item.unit?.short_name,
    })),
  };
}
